export const removeInlineSeo = () => {
  const seoH1 = document.querySelector('.seo-only-h1');

  if (seoH1) seoH1.remove();
}

export const shouldDisplayTheme = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hasThemeOrDesignCode = !!urlParams.has('theme') || !!urlParams.has('design_code');
  const hasProductParam = !!urlParams.has('product');

  return !hasProductParam && hasThemeOrDesignCode;
}
